import React, { useContext, useState } from "react";
import toast from "react-hot-toast";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import FolderDropzone from "../component/Dropzone";
import { AppContext } from "../context/context";
import { uploadPdf } from "../hooks/uploadPdf";

const EditPdfModal = ({ selectedPdf, setEditPdfModalOpen }) => {
  //global states
  const { fetchDocuments, state } = useContext(AppContext);

  //selected file
  const [files, setFiles] = useState([]);

  //loading state for disabling events
  const [laoding, setLoading] = useState(false);

  //boolean state for verifying same file name
  const [isFileNameNotSame, setIsFileNameNotSame] = useState(false);

  //handle close modal
  const handleClose = () => {
    setEditPdfModalOpen(false);
  };

  //handle submit edit file
  const handleSubmit = async () => {
    toast.loading("loading...");
    setLoading(true);
    try {
      let data = await uploadPdf(files[0], state?.activeTab);
      toast.dismiss();
      if (data.status === "Docs uploaded successfully.") {
        toast.success("PDF edited successfully.");
      } else {
        toast.error(data.status);
      }
      setLoading(false);
      setEditPdfModalOpen(false);
      fetchDocuments(state?.activeTab);
    } catch (err) {
      toast.dismiss();
      toast.error(`${err} (${files[0].name})`);
      console.log("Error: ", err);
    }
  };

  // handle unselect/remove file
  const handleRemoveFile = (i) => {
    setFiles((prev) => prev.filter((file, index) => i !== index));
  };

  return (
    <div className="editPdfModal flex items-center justify-center h-full w-screen absolute inset-0 bg-[grey] z-[1] bg-opacity-50">
      <div className="modal bg-white rounded-md p-6 w-[30rem] relative">
        <div
          onClick={handleClose}
          className="w-7 h-7 p-2 absolute top-[8px] right-[15px] cursor-pointer"
        >
          <img className="h-full w-full" src={assetsManager.crossIcon} alt="" />
        </div>
        <div className="modal-header text-center text-xl text-[#424242] font-medium">
          Edit PDF
        </div>
        <div className="modal-body">
          <div className="flex flex-col">
            <label className="text-sm text-[#676767] mb-1">
              Uploaded PDF Name
            </label>
            <input
              className="p-2 rounded-[4px] text-[#8A8A8A] text-sm border-[0.5px] border-[#E3E3E3] disabled:cursor-not-allowed"
              value={selectedPdf?.name}
              disabled
            />
            {isFileNameNotSame && (
              <div className="text-right text-sm text-[#A83E3E]">
                The uploaded PDF should have the same name*
              </div>
            )}
          </div>
          <div className={`dropZone mt-5 cursor-pointer`}>
            <FolderDropzone
              setIsFileNameNotSame={setIsFileNameNotSame}
              selectedPdfName={selectedPdf?.name}
              multiSelect={false}
              setFiles={setFiles}
            />
          </div>
          {files?.length > 0 && (
            <div className="filesList mt-2">
              <p className="text-[#676767] font-medium text-md">Uploading</p>
              <ul className="mt-1 flex flex-col gap-2 max-h-[8rem] overflow-auto">
                {files?.map((file, i) => (
                  <li
                    className="border-[0.5px] border-[#E3E3E3] text-sm flex items-center justify-between p-2 rounded-[4px]"
                    key={file.name}
                  >
                    <p>{file.name}</p>
                    <img
                      className="cursor-pointer"
                      onClick={() => handleRemoveFile(i)}
                      src={assetsManager.crossIconForUploadFile}
                      alt=""
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
          <button
            className="bg-[#C7222A] text-white text-sm flex items-center justify-center w-full h-[39px] mt-3 rounded-[4px] disabled:cursor-not-allowed"
            onClick={handleSubmit}
            disabled={
              files?.length === 0 ||
              files[0]?.name !== selectedPdf?.name ||
              laoding
            }
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPdfModal;
